import type React from 'react'
import { MaterialCard } from '../ui/MaterialCard'

interface ChartContainerProps {
    title: string
    subtitle?: string
    icon?: React.ReactNode
    children: React.ReactNode
    className?: string // Optional custom class
    rightAction?: React.ReactNode
}

export const ChartContainer: React.FC<ChartContainerProps> = ({
    title,
    subtitle,
    icon,
    children,
    className = '',
    rightAction,
}) => {
    return (
        <MaterialCard
            className={`p-0 mb-6 border-none shadow-2xl bg-white/40 dark:bg-slate-900/40 backdrop-blur-2xl ring-1 ring-white/60 dark:ring-slate-700/60 border border-white/40 dark:border-slate-700/40 group relative overflow-hidden ${className}`}
        >
            {/* Header */}
            <div className="px-4 sm:px-6 py-3 sm:py-4 border-b border-white/40 dark:border-slate-700/40 bg-white/40 dark:bg-slate-800/40 backdrop-blur-md rounded-t-[20px] flex flex-col sm:flex-row sm:items-center justify-between relative z-10 gap-3 sm:gap-4">
                <div className="flex items-center gap-2 sm:gap-3 min-w-0 flex-1">
                    {icon && (
                        <div className="p-2 sm:p-2.5 bg-white/80 dark:bg-slate-800/80 rounded-xl text-indigo-600 dark:text-indigo-400 shadow-sm ring-1 ring-black/5 dark:ring-white/10 backdrop-blur-sm shrink-0 hidden sm:block">
                            {icon}
                        </div>
                    )}
                    <div className="min-w-0 flex-1 pr-2">
                        <h3
                            className="text-[13px] sm:text-sm font-black text-slate-800 dark:text-slate-100 uppercase tracking-tight leading-none truncate whitespace-nowrap overflow-hidden text-ellipsis"
                            title={title}
                        >
                            {title}
                        </h3>
                        {subtitle && (
                            <p
                                className="text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider mt-1 truncate"
                                title={subtitle}
                            >
                                {subtitle}
                            </p>
                        )}
                    </div>
                </div>
                {rightAction && (
                    <div className="shrink-0 self-end sm:self-auto w-full sm:w-auto overflow-x-auto pb-1 sm:pb-0 scrollbar-hide pt-1 sm:pt-0">
                        {rightAction}
                    </div>
                )}
            </div>

            {/* Content */}
            <div className="relative z-10">{children}</div>
        </MaterialCard>
    )
}
